import { Dispatch, SetStateAction } from 'react';
import { BankAccount } from 'interfaces';
import { API } from '../data/30pay.api';
import { get } from '../scripts';

export const _getCardNumbers = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Omit<BankAccount, 'iBan'>[] | undefined>>,
    setSelectedData?: Dispatch<SetStateAction<Omit<BankAccount, 'iBan'> | undefined>>,
) => {
    setLoading(true);
    try {
        await get<Omit<BankAccount, 'iBan'>[]>(API.bankAccount.cardNumber).then((response) => {
            setLoading(false);
            setData(response.value.value);
            setSelectedData && response.value.value.length > 0 && setSelectedData(response.value.value[0]);
        });
    } catch (error) {
        console.error(error);
    } finally {
        setLoading(false);
    }
};

export const _getIBans = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Omit<BankAccount, 'cardNumber'>[] | undefined>>,
    setSelectedData?: Dispatch<SetStateAction<Omit<BankAccount, 'cardNumber'> | undefined>>,
) => {
    setLoading(true);
    try {
        await get<Omit<BankAccount, 'cardNumber'>[]>(API.bankAccount.iBan).then((response) => {
            setLoading(false);
            setData(response.value.value);
            setSelectedData && response.value.value.length > 0 && setSelectedData(response.value.value[0]);
        });
    } catch (error) {
        console.error(error);
    } finally {
        setLoading(false);
    }
};